import { EventEmitter } from 'events';
class _AccountWidgetAssetsController {
    constructor() {
        this._Account = null;
        this._AssetsArray = [];
        this._SelectedAsset = null;
        this._eventEmitter = new EventEmitter();
    }
    set Account(account) {
        this._Account = account;
        this.PopulateAssets(account);
    }
    PopulateAssets(account) {
        this._AssetsArray = [];
        for (const key in account.assetBalances) {
            this._AssetsArray.push(account.assetBalances[key].Asset);
        }
    }
    get AssetsArray() {
        return this._AssetsArray;
    }
    set SelectedAsset(asset) {
        this._SelectedAsset = asset;
        this.OnOnAssetChangedEmit(asset);
    }
    get SelectedAsset() {
        return this._SelectedAsset;
    }
    subscribeOnAssetChanged(callback) {
        this._eventEmitter.on('OnAssetChanged', callback);
    }
    unsubscribeOnAssetChanged(callback) {
        this._eventEmitter.off('OnAssetChanged', callback);
    }
    OnOnAssetChangedEmit(value) {
        this._eventEmitter.emit('OnAssetChanged', value);
    }
    clean() {
        this._Account = null;
        this._SelectedAsset = null;
        this._AssetsArray = [];
    }
}
export const AccountWidgetAssetsController = new _AccountWidgetAssetsController();
